module.exports = __webpack_public_path__ + "img/certificate-6.45422603.png";